module.exports = __webpack_public_path__ + "img/office-building.03ebc98b.svg";